"use client";
import React from 'react'
import { InfiniteMovingCards } from "./InfiniteMovingCards";

const testimonials = [
    {
      name: "Charles Dickens",
      title: "ReactJS",
      icon: "reactjs"
    },
    {
      name: "William Shakespeare",
      title: "VueJS",
      icon: "vuejs"
    },
    {
      name: "Edgar Allan Poe",
      title: "Docker",
      icon: "docker"
    },
    {
      name: "Jane Austen",
      title: "Kubernetes",
      icon: "kubernetes"
    },
    {
      name: "Herman Melville",
      title: "AWS",
      icon: "aws"
    },
    {
      name: "Herman Melville 2",
      title: "GIT",
      icon: "git"
    },
    {
      name: "JAVA",
      title: "JAVA",
      icon: "java"
    },
    {
      name: "GO",
      title: "GO",
      icon: "go"
    }
  ];
  

const InfiniteCards = () => {
  return (
    <div className="flex flex-col items-center">
      <div
        className="h-[200px] max-h-[200px] rounded-md flex flex-col antialiased items-center relative overflow-hidden w-full"
      >
        <InfiniteMovingCards
          items={testimonials}
          direction="right"
          speed="normal"
        />
      </div>
    </div>
  );
};


export default InfiniteCards;